/**
 * Zet jQuery op window vóór andere scripts (Bootstrap, Slick, etc.) laden.
 * Moet als eerste geïmporteerd worden in app.js.
 */
import $ from 'jquery';
globalThis.jQuery = globalThis.$ = $;
if (typeof window !== 'undefined') {
    window.jQuery = window.$ = $;
}
